import 'leaflet.pm'
import React from 'react'
import { Form, Input } from 'semantic-ui-react'
import { Map, TileLayer, Marker, Popup } from 'react-leaflet'


class CoordinatesField extends React.Component {

  map = React.createRef()
  latlonRegexp = /^-?\d+\.?(\d+)?$/

  constructor(props) {
    super(props)
    const value = props.value || { lat: 51.505, lon: -0.09 }
    this.state = {
      center: [value.lat, value.lon],
      marker: [value.lat, value.lon],
      zoom: 6,
    }
  }

  refreshPosition = (viewport) => {
    this.setState({ center: viewport.center, zoom: viewport.zoom })
  }

  handleSelectPoint = (e) => {
    let lat = e.latlng.lat
    if (lat > 90) {
      lat = 90
    } else if (lat < -90) {
      lat = -90
    }
    let lon = e.latlng.lng
    if (lon > 180) {
      lon = 180
    } else if (lon < -180) {
      lon = -180
    }
    this.props.onChange({ lat, lon })
    this.setState({ marker: [lat, lon] })
  }

  handleChangeLat = (value) => {
    value = value.replace(',', '.')
    if (!value) { value = '0.0' }
    if (!this.latlonRegexp.test(value)) { return }
    value = parseFloat(value)
    this.props.onChange({ lat: value, lon: this.state.marker[1] })
    this.setState({
      marker: [value, this.state.marker[1]],
      center: [value, this.state.marker[1]],
    })
  }

  handleChangeLon = (value) => {
    value = value.replace(',', '.')
    if (!value) { value = '0.0' }
    if (!this.latlonRegexp.test(value)) { return }
    value = parseFloat(value)
    this.props.onChange({ lon: value, lat: this.state.marker[0] })
    this.setState({
      marker: [this.state.marker[0], value],
      center: [this.state.marker[0], value],
    })
  }

  reset = () => {
    const value = this.props.value || { lat: 51.505, lon: -0.09 }
    this.setState({
      center: [value.lat, value.lon],
      marker: [value.lat, value.lon],
      zoom: 6,
    })
  }

  render() {
    return (
      <div>
        <Map
          maxBounds={[
            [-90, -180],
            [90, 180],
          ]}
          ref={this.map}
          center={this.state.center}
          zoom={this.state.zoom}
          style={{ height: '300px' }}
          onViewportChanged={this.refreshPosition}
          onClick={this.handleSelectPoint}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            noWrap={true}
          />
          <Marker position={this.state.marker}>
            <Popup>A pretty CSS3 popup.<br />Easily customizable.</Popup>
          </Marker>
        </Map>
        <Form.Group widths='equal'>
          <Form.Field>
            <label>Широта</label>
            <Input onChange={(e, { value }) => this.handleChangeLat(value)} value={this.state.marker[0]}/>
          </Form.Field>
          <Form.Field>
            <label>Долгота</label>
            <Input onChange={(e, { value }) => this.handleChangeLon(value)} value={this.state.marker[1]}/>
          </Form.Field>
        </Form.Group>
      </div>
    )
  }
}

export default CoordinatesField
